import React, { Component } from 'react'
import { connect } from 'react-redux'
class TicketResult extends Component {
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        total: 0,
        results: false
      }
    })
    return true
  }
  render () {
    return (
      <a key={'result' + this.props.result.ticketRef} onClick={e => this.clearSearch()} href={'#/ticket/' + this.props.result.ticketRef} className={'list-group-item ' + (this.props.active ? 'active list-group-item-active' : '')}>
        <div className='search-icon-wrapper'>
          <i className={'fa fa-fw fa-commenting'} />
        </div>
        <div className='flow-search-result-wrapper'>
          <h4 className='list-group-item-heading'>{this.props.result.state.status} #{this.props.result.ticketRef} - {this.props.result.title} <small>{(this.props.result.spReference ? <span>Reference: {this.props.result.spReference}</span> : '')} {(this.props.result.state.assignedTo ? <span>Assigned to: {this.props.result.state.assignedTo}</span> : '')}</small></h4>
          <p className='list-group-item-text'>{(this.props.result.description || '').replace(/,/g, ' ').replace(/ +/, ' ')}</p>
        </div>
      </a>
    )
  }
}
// eslint-disable-next-line
TicketResult = connect(state => state.siteReducer)(TicketResult)
export default TicketResult



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/search/TicketResult.js